import React from 'react';

const SvgArrow2 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    {...props}
  >
    <path
      d="M24 12.7598C24 6.13073 18.629 0.759766 12 0.759766C5.37097 0.759766 0 6.13073 0 12.7598C0 19.3888 5.37097 24.7598 12 24.7598C18.629 24.7598 24 19.3888 24 12.7598ZM2.32258 12.7598C2.32258 7.41299 6.65323 3.08235 12 3.08235C17.3468 3.08235 21.6774 7.41299 21.6774 12.7598C21.6774 18.1065 17.3468 22.4372 12 22.4372C6.65323 22.4372 2.32258 18.1065 2.32258 12.7598ZM5.80645 13.7275V11.792C5.80645 11.4727 6.06774 11.2114 6.3871 11.2114H12V7.96944C12 7.4517 12.6242 7.19525 12.9919 7.55815L17.7823 12.3485C18.0097 12.5759 18.0097 12.9436 17.7823 13.1711L12.9919 17.9614C12.6242 18.3291 12 18.0678 12 17.5501V14.3082H6.3871C6.06774 14.3082 5.80645 14.0469 5.80645 13.7275Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgArrow2;
